import { Navigate, Outlet, useLocation } from "react-router";
import { getSessionToken } from "../lib/auth";

function RequireAuth() {
  const location = useLocation();
  const token = getSessionToken();

  if (!token) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

export default RequireAuth;
